import { render, staticRenderFns } from "./FinanceReportRelation.vue?vue&type=template&id=1647d540&scoped=true&"
import script from "./FinanceReportRelation.vue?vue&type=script&lang=js&"
export * from "./FinanceReportRelation.vue?vue&type=script&lang=js&"
import style0 from "./FinanceReportRelation.vue?vue&type=style&index=0&id=1647d540&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1647d540",
  null
  
)

export default component.exports